import { createBP } from "@amzn/aws-marketing-identity-kit-essentials";
export const createBuilderProfileAdapter = (appId, config) => {
    if (typeof window === "undefined") {
        return null;
    }
    if (window.BuilderProfile &&
        typeof window.BuilderProfile.setProfile === "function" &&
        typeof window.BuilderProfile.checkAlias === "function" &&
        typeof window.BuilderProfile.setAlias === "function" &&
        typeof window.BuilderProfile.addEmail === "function" &&
        typeof window.BuilderProfile.updateEmail === "function" &&
        typeof window.BuilderProfile.deleteEmail === "function" &&
        typeof window.BuilderProfile.requestEmailVerification === "function" &&
        typeof window.BuilderProfile.verifyEmail === "function" &&
        typeof window.BuilderProfile.me === "function") {
        return {
            SetProfile: (data, userId) => window.BuilderProfile.setProfile(data, userId),
            CheckAlias: (alias) => window.BuilderProfile.checkAlias(alias),
            SetAlias: (alias, userId) => window.BuilderProfile.setAlias(alias, userId),
            AddEmail: (email, type) => window.BuilderProfile.addEmail(email, type),
            UpdateEmail: (email, emailType) => window.BuilderProfile.updateEmail(email, emailType),
            DeleteEmail: (email, profileId) => window.BuilderProfile.deleteEmail(email, profileId),
            RequestEmailVerification: (email, locale) => window.BuilderProfile.requestEmailVerification(email, locale),
            VerifyEmail: (email, otp) => window.BuilderProfile.verifyEmail(email, otp),
            me: () => window.BuilderProfile.me(),
        };
    }
    return createBP(config.env, config.bpConfig)
        .init(appId, {})
        .then((BP) => ({
        SetProfile: (data, userId) => BP.setProfile(data, userId),
        CheckAlias: (alias) => BP.checkAlias(alias),
        SetAlias: (alias, userId) => BP.setAlias(alias, userId),
        AddEmail: (email, type, profileId) => BP.addEmail(email, type, profileId),
        UpdateEmail: (email, emailType, profileId) => BP.updateEmail(email, emailType, profileId),
        DeleteEmail: (email, profileId) => BP.deleteEmail(email, profileId),
        RequestEmailVerification: (email, locale) => BP.requestEmailVerification(email, locale),
        VerifyEmail: (email, profileId, otp) => BP.verifyEmail(email, profileId, otp),
        me: () => BP.me(),
    }));
};
//# sourceMappingURL=builder-profile.js.map